import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import { StyledButton } from '../../../Components/Generics.styled';

const AdServicesDetailsContainer = styled.div`
    height: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
`;

const Title = styled.div`
    margin-top: 100px;
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    text-align: center;
`;

const PricingProductCard = styled.div`
    background-color: #fafbf7;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 20px;
    width: 800px;
    margin: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const TierCard = styled.div`
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    margin: 10px 0;
`;

const TierTitle = styled.h3`
    font-size: 1.2rem;
`;

const TierDescription = styled.p`
    font-size: 1rem;
    color: #333;
`;

const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    margin-top: 5px;
`;

const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const Image = styled.img`
    height: 200px;
    object-fit: contain;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;

    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledCheckbox = styled(Checkbox)``;

const AdServicesDetails = ({ selectedService, selectedTiers, setSelectedTiers, history, resetFields }) => {
    const handleTierSelection = (tierId, optionPrice) => {
        setSelectedTiers((prevSelectedTiers) => {
            // Create a new object to store the selected tiers
            const updatedSelectedTiers = {};

            // Toggle the selected state of the clicked tier and set its price
            updatedSelectedTiers[tierId] = {
                checked: !prevSelectedTiers[tierId]?.checked,
                price: optionPrice,
            };

            return updatedSelectedTiers;
        });
    };

    const noTiersSelected = !Object.values(selectedTiers).some((tier) => tier?.checked);

    const pricingTiers = [];

    for (let i = 1; i <= 10; i++) {
        if (selectedService?.adServiceId) {
            const optionLabel = selectedService[`option${i}Label`] || '';
            const optionPrice = selectedService[`option${i}Price`] || 0;
            const tierId = `option${i}`;

            if (selectedService[`hasOption${i}`] && optionLabel && optionPrice) {
                pricingTiers.push(
                    <TierCard key={tierId}>
                        <TierTitle>{optionLabel.charAt(0).toUpperCase() + optionLabel.slice(1)}</TierTitle>
                        <TierDescription>${optionPrice}</TierDescription>
                        <CheckboxLabel>
                            <StyledCheckbox
                                type="checkbox"
                                checked={selectedTiers[tierId]?.checked || false}
                                onChange={() => handleTierSelection(tierId, optionPrice)}
                            />
                            Select
                        </CheckboxLabel>
                    </TierCard>
                );
            }
        }
    }

    console.log(selectedTiers, 'tiers');

    const onBackButton = () => {
        resetFields();
        history.push('/portal/adServices/viewAdServices');
    };

    return (
        <AdServicesDetailsContainer>
            <Title>Pricing</Title>
            <PricingProductCard>
                <h2>{selectedService?.adServiceName}</h2>
                <p>{selectedService?.adServiceDescription}</p>
                <ImageContainer>
                    <Image src={selectedService?.azureFileURL} alt={selectedService?.adServiceName} />
                </ImageContainer>

                <div className="pricing-tiers">{pricingTiers}</div>
            </PricingProductCard>
            <StyledNavButtons>
                <StyledButton variant="contained" color="primary" onClick={() => onBackButton()}>
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => history.push('/portal/adServices/checkout')}
                    disabled={noTiersSelected}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </AdServicesDetailsContainer>
    );
};

AdServicesDetails.propTypes = {
    selectedProducts: propTypes.shape({}),
    selectedTiers: propTypes.shape({}),
    setSelectedTiers: propTypes.func,
    resetFields: propTypes.func,
    history: propTypes.shape({ push: propTypes.func }),
    selectedService: propTypes.shape({
        adServiceId: propTypes.number,
        adServiceName: propTypes.string,
        adServiceDescription: propTypes.string,
        azureFileURL: propTypes.string,
    }),
};

AdServicesDetails.defaultProps = {
    selectedProducts: {},
    setSelectedProducts: () => {},
    productData: [],
    history: [],
};

export default AdServicesDetails;
